import { fromJS } from 'immutable';
import { createSymbols } from 'utils/helpers';
import baseReducer from 'redux/baseReducer';

const initialState = fromJS({});

export const {
    RESET_FORM,
    UPDATE_STATE,
    UPDATE_VALUE,
} = createSymbols([
    'RESET_FORM',
    'UPDATE_STATE',
    'UPDATE_VALUE',
]);

const updateState = (state, action) => state.set(action.form, fromJS(action.state));
const updateValue = (state, action) => state.setIn([action.form, action.key], action.value);
const resetForm = (state, action) => state.set(action.form, fromJS({}));

export default baseReducer(
    initialState,
    {
        [RESET_FORM]: resetForm,
        [UPDATE_STATE]: updateState,
        [UPDATE_VALUE]: updateValue,
    }
);



// WEBPACK FOOTER //
// ./src/redux/filter/reducer.js